import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material';
import {FontAwesomeService} from '@services/font-awesome.service';
import {Store} from '@ngrx/store';
import {AppState} from '@store/reducers';
import {SnackbarClose} from '@store/actions';

interface Data {
  message: string;
  error: boolean;
}

@Component({
  selector: 'snack-bar-component',
  template: `
    <div class="container">
      <div>
        <ng-container *ngIf="data.error; else successTemplate">
          <fa-icon [icon]="faService.faExclamationCircle" class="fail"></fa-icon>
        </ng-container>
        <ng-template #successTemplate>
          <fa-icon [icon]="faService.faCheckCircle" class="success"></fa-icon>
        </ng-template>
        <br/>
        <span>{{data.message}}</span>
      </div>
      <fa-icon [icon]="faService.faTimes" class="close" (click)="handleClose()"></fa-icon>
    </div>
  `,
  styles: [`
    :host {
      width: 100%;
    }
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;

    }
    .container div {
      display: flex;
      align-items: center;
    }
    .container div fa-icon {
      margin-right: 10px;
    }
    .success {
      color: #4ce587;
      font-size: 20px;
    }
    .fail {
      font-size: 20px;
      color: #ff4f58;
    }
    span {

      max-width: 200px;
    }
    span, .close {
      color: #dadada;
      font-size: 12px;
      font-weight: 400;
    }
    .close {
      font-size: 20px;
      cursor: pointer;
    }
  `]
})
export class SnackBarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: Data,
    public faService: FontAwesomeService,
    private store: Store<AppState>
  ) {}

  handleClose() {
    this.store.dispatch(new SnackbarClose());
  }
}




// WEBPACK FOOTER //
// ./src/app/components/snackbar/snackbar.component.ts